export const formatCurrency = (value: string): string => {
  if (value.includes('$')) return value
  const numberValue = parseFloat(value)
  if (isNaN(numberValue)) return value
  return numberValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

export const parseCurrency = (value: string): number => {
  const numericValue = value.replace(/[$,]/g, '')
  return parseFloat(numericValue) || 0
}
